/** imported components

  * BreadcrumbsItem for ===> dynamic breadcrumb component of react.
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  * Helmet ===> for add specific title & CSS for the page.
  * serviceProvider for ===> working with api
  * PrepareHomeView ===> custom view component

**/

import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {PrepareHomeView} from './home-view';
import serviceProvider from '../../services/axios'
//PrepareHomeCtrl component
export const PrepareHomeCtrl=(props)=>{
    const [results, setResults] = useState([]);
    const [resultstask, setResultsTask] = useState([]);
    const [defaultData,setDefaultData]=useState([]);
    const [filterPlants, setFilterPlants] = useState(""); 
    const [filterPlantsTask, setFilterPlantsTask] = useState(""); 
    const [onrefresh, setOnrefresh] = useState(false); 
    const user = JSON.parse(localStorage.getItem("userData"));
	const login = localStorage.getItem("isLoggedIn");
    const usid = user ? user.uid : 0;
    const gid = user ? user.group_id : 0;
    if (!login) {
		return <Redirect to="/sign-in" />;
	}
    useEffect(() => {
          props.handleExpandFal();
          const search = async () => {
              const apiUrl = `/home?param=homedata&filterPlants=${filterPlants}&uid=${usid}`;
              const { data } = await serviceProvider.get(apiUrl,true,{});
              setDefaultData(data);
              setResults(data);
          };
          search();
      }, [filterPlants,onrefresh]);
      useEffect(() => {
        const search = async () => {
            const apiUrl = `/Taskcentershome?param=task&filterPlants=${filterPlantsTask}&uid=${usid}&gid=${gid}`;
            const { data } = await serviceProvider.get(apiUrl,true,{});
            setResultsTask(data);
        };
        search();
    }, [filterPlantsTask,onrefresh]);

		
    return(
        <>
            {/* link css */}
            <Helmet>
			<title>Home | SmarterChains</title>
				<meta name="description" content="Home" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="stylesheet" href={require('./home.scss').require} />
            </Helmet>
            <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
            {/* <PrepareHomeView {...props}/>*/}
            {/* custom view component */}
            <PrepareHomeView homeData={results} resultstask={resultstask} defaultData={defaultData} onFilter={setFilterPlants}  onrefresh={onrefresh} setOnrefresh={setOnrefresh} onFilterPlantsTask={setFilterPlantsTask}  {...props} />
        </>
    )
}